import 'vite/modulepreload-polyfill';
import './src/scripts/index';
import svgxhr from './src/scripts/helpers/svgxhr';
import.meta.glob('./src/static/images/**/*');
import { PUBLIC_PATH } from './config';

svgxhr({ filename: `${PUBLIC_PATH}images/svgsheet.svg` });
